export enum CONTENTS {
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452623
     */
    ARCHIVE_SUCCESS = 'CONTENT_CHANGE_STATUS_ARCHIVE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=603869131
     */
    ARCHIVED_STATUS_NOTIFICATION = 'CONTENTS.ARCHIVED_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627240
     */
    CONFIRM_ARCHIVE = 'CONTENT_ADMIN.CONFIRM_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540554292
     */
    CONFIRM_UNARCHIVE = 'CONTENT_ADMIN.CONFIRM_UNARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=537656077
     */
    CONFIRM_UNPUBLISH = 'CONTENT_ADMIN.CONFIRM_UNPUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593463656
     */
    CONTENT_EXPIRING_SOON = 'CONTENTS.CONTENT_EXPIRING_SOON',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593463624
     */
    CONTENT_NOT_PUBLISHED_YET = 'CONTENTS.CONTENT_NOT_PUBLISHED_YET',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=493733631
     */
    CONTENT_PUBLISHED = 'CONTENTS.CONTENT_PUBLISHED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=493733904
     */
    CONTENT_PUBLISHED_NOTIFICATION_DESCRIPTION = 'CONTENTS.CONTENT_PUBLISHED_NOTIFICATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=93565729
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_ALL_FEED = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.ALL_FEED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=92200991
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_CHANGE_SETTINGS = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.CHANGE_SETTINGS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=92201150
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_FEED_LIST_MESSAGE = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.FEED_LIST_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=92200905
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_PUBLISH = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.PUBLISH',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=92201143
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_SINGLE_FEED = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.SINGLE_FEED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=92201156
     */
    CONTENT_SETTINGS_NOTIFICATION_CONFIRM_DIALOG_TITLE = 'FRONT.CONTENT_SETTINGS.NOTIFICATION.CONFIRM_DIALOG.TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=165415697
     */
    CONTENT_UNPUBLISHED = 'REPORTS.ACCEPT_REPORT_CONTENT_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68593157
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_OFF_ACTION = 'FRONT.CONTEXTUAL_ACTIONS.TRANSLATION_OFF_ACTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=68593154
     */
    CONTEXTUAL_ACTIONS_TRANSLATION_ON_ACTION = 'FRONT.CONTEXTUAL_ACTIONS.TRANSLATION_ON_ACTION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452630
     */
    DELETE_CONFIRM_CONTENT = 'CONTENT_DELETE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452629
     */
    DELETE_CONFIRM_TITLE = 'CONTENT_DELETE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452631
     */
    DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=340580608
     */
    DISPLAY_PUBLICATION = 'CONTENTS.DISPLAY_PUBLICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=28364221
     */
    DRAFT_IN_PROGRESS = 'CONTENT.LAST_REVISION.DRAFT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593463466
     */
    DRAFT_STATUS_NOTIFICATION = 'CONTENTS.DRAFT_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=8453628
     */
    EDIT_CONTENT = 'FRONT.FROALA.EDITCONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=594692466
     */
    EDIT_THIS_CONTENT = 'CONTENTS.EDIT_THIS_CONTENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452719
     */
    EDITORS = 'CONTENT_SETTINGS_EDITORS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593447266
     */
    EXPIRED_STATUS_NOTIFICATION = 'CONTENTS.EXPIRED_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593463557
     */
    EXPIRES_SOON_STATUS_NOTIFICATION = 'CONTENTS.EXPIRES_SOON_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=546834057
     */
    EXPLAIN_ARCHIVE = 'CONTENT_ADMIN.EXPLAIN_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540554629
     */
    EXPLAIN_UNARCHIVE_ONE = 'CONTENT_ADMIN.EXPLAIN_UNARCHIVE_ONE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540218486
     */
    EXPLAIN_UNPUBLISH_ONE = 'CONTENT_ADMIN.EXPLAIN_UNPUBLISH_ONE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452947
     */
    FEED_REQUIRED = 'FEED_REQUIRED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=711802042
     */
    IS_CONTENT_UP_TO_DATE = 'CONTENTS.IS_CONTENT_UP_TO_DATE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=54691671
     */
    NEW_CONTENT = 'FRONT.CONTRIBUTION_MENU.NEW_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=158106895
     */
    NO_CONTENT = 'CONTENTS.NO_CONTENT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452689
     */
    PUBLISH_CONFIRM_CONTENT = 'CONTENT_SET_TO_LIVE_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=711802682
     */
    PUBLISHED_TO_VALIDATE_STATUS_NOTIFICATION = 'CONTENTS.PUBLISHED_TO_VALIDATE_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=711803424
     */
    PUBLISHED_WITH_DRAFT_STATUS_NOTIFICATION = 'CONTENTS.PUBLISHED_WITH_DRAFT_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593990729
     */
    REFUSED_STATUS_NOTIFICATION = 'CONTENTS.REFUSED_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=615107050
     */
    REQUEST_REVISION_CONFIRM_DIALOG_CONTENT = 'ADMIN_WORKFLOW_REFUSE_DESCR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612520302
     */
    REQUEST_REVISION_LABEL = 'DESIGNER.REFUSE_CONTENT_PUBLICATION_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=661627388
     */
    REVIEW_WORKFLOW_LABEL = 'CONTENT.REVIEW_WORKFLOW_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612088002
     */
    REVISION_REQUESTED = 'DESIGNER.REVISION_REQUESTED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593458174
     */
    SCHEDULED_STATUS_NOTIFICATION = 'CONTENTS.SCHEDULED_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=580104813
     */
    SELECT_CONTENT_TYPE = 'CONTENT.SELECT_CONTENT_TYPE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452723
     */
    SETTINGS_HIGHLIGHTED_FEEDS = 'CONTENT_SETTINGS_HIGHLIGHTED_FEEDS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27106798
     */
    SETTINGS_HIGHLIGHTED_FEEDS_HELP = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_HIGHLIGHTED_FOR_HELPER',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452766
     */
    SETTINGS_VISIBLE_BY = 'CONTENT_SETTINGS_VISIBLE_BY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=874630033
     */
    SETTINGS_VISIBLE_BY_GROUP = 'CONTENT_SETTINGS.VISIBLE_BY_GROUP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=874630079
     */
    SETTINGS_VISIBLE_BY_SPACE = 'CONTENT_SETTINGS.VISIBLE_BY_SPACE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=874636184
     */
    SETTINGS_VISIBLE_BY_ERROR = 'CONTENT_SETTINGS.VISIBLE_BY_ERROR',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=27106794
     */
    SETTINGS_VISIBLE_BY_HELP = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=873893044
     */
    SETTINGS_VISIBLE_BY_GROUP_HELPER = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_GROUP_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=873893457
     */
    SETTINGS_VISIBLE_BY_SPACE_HELPER = 'ADMIN.TEMPLATE.CONTENT_SETTINGS_VISIBLE_BY_SPACE_HELPER',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593477114
     */
    STATUS_NOTIFICATION_DESCRIPTION = 'CONTENTS.STATUS_NOTIFICATION_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=623826373
     */
    SUBMIT_FOR_REVIEW_CONFIRM_DIALOG_CONTENT = 'DESIGNER.SUBMIT_FOR_REVIEW_CONFIRM_DIALOG_CONTENT',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612088654
     */
    SUBMIT_FOR_REVIEW_LABEL = 'DESIGNER.SUBMIT_FOR_REVIEW_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612084251
     */
    SUBMITTED_FOR_REVIEW_MESSAGE = 'DESIGNER.SUBMITTED_FOR_REVIEW_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=540627366
     */
    TO_REVERSE_ARCHIVE = 'CONTENT_ADMIN.TO_REVERSE_ARCHIVE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=593463514
     */
    TO_VALIDATE_STATUS_NOTIFICATION = 'CONTENTS.TO_VALIDATE_STATUS_NOTIFICATION',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452794
     */
    TYPES = 'CONTENT_TYPES',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452627
     */
    UNARCHIVE_SUCCESS = 'CONTENT_CHANGE_STATUS_UNARCHIVE_SUCCESS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452686
     */
    UNPUBLISH = 'CONTENT_SET_TO_DRAFT',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452628
     */
    UNPUBLISH_SUCCESS = 'CONTENT_CHANGE_STATUS_UNPUBLISH_SUCCESS',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=612083656
     */
    UNPUBLISHED_SAVED_CHANGES_WARNING_MESSAGE = 'DESIGNER.UNPUBLISHED_SAVED_CHANGES_WARNING_MESSAGE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=28364227
     */
    VERSION_REFUSED = 'CONTENT.LAST_REVISION.REFUSED',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=28366240
     */
    VERSION_TO_VALIDATE = 'CONTENT.LAST_REVISION.TO_VALIDATE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452767
     */
    WRITE_ON_BEHALF_OF = 'CONTENT_SETTINGS_WRITE_INSTEAD_OF',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=617491450
     */
    WRITING_ON_BEHALF_OF = 'CONTENTS.WRITING_ON_BEHALF_OF',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=870025118
     */
    WRITTEN_ON_BEHALF_OF = 'CONTENTS.WRITTEN_ON_BEHALF_OF',
}
